export default __webpack_public_path__ + "static/media/magenta1.e57555ab.png";